/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum HubbleShipmentFiltersQueryBookingStatus {
  Any = "Any",
  NotBooked = "NotBooked",
  Booked = "Booked",
}

export function instanceOfHubbleShipmentFiltersQueryBookingStatus(
  value: any,
): boolean {
  for (const key in HubbleShipmentFiltersQueryBookingStatus) {
    if (
      Object.prototype.hasOwnProperty.call(
        HubbleShipmentFiltersQueryBookingStatus,
        key,
      )
    ) {
      if (
        HubbleShipmentFiltersQueryBookingStatus[
          key as keyof typeof HubbleShipmentFiltersQueryBookingStatus
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function HubbleShipmentFiltersQueryBookingStatusFromJSON(
  json: any,
): HubbleShipmentFiltersQueryBookingStatus {
  return HubbleShipmentFiltersQueryBookingStatusFromJSONTyped(json, false);
}

export function HubbleShipmentFiltersQueryBookingStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HubbleShipmentFiltersQueryBookingStatus {
  return json as HubbleShipmentFiltersQueryBookingStatus;
}

export function HubbleShipmentFiltersQueryBookingStatusToJSON(
  value?: HubbleShipmentFiltersQueryBookingStatus | null,
): any {
  return value as any;
}

export function HubbleShipmentFiltersQueryBookingStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): HubbleShipmentFiltersQueryBookingStatus {
  return value as HubbleShipmentFiltersQueryBookingStatus;
}
